import styles from './scheduleLoading.module.scss'
import { Skeleton } from 'antd'
import { PatientScheduleSkeleton } from 'features/Home/Book/Booking/Schedule/PatientSchedule/PatientScheduleSkeleton/PatientScheduleSkeleton'

export const ScheduleLoading = () => {
  return (
    <>
      <Skeleton.Node className={styles.skeletonButton} />
      <PatientScheduleSkeleton />
    </>
  )
}
